import { useState } from "react";
import { Settings } from "lucide-react";
import { useTran } from "@/hooks";
import { PageHeader } from "@/components/common";
import ProfileSection from "../components/ProfileSection";
import PasswordSection from "../components/PasswordSection";
import { useSettingsProfileForm } from "../hooks/useSettingsProfileForm";
import { usePasswordForm } from "../hooks/usePasswordForm";
import { User, KeyRound } from "lucide-react";

const SectionSwitcher = ({ tabs, value, onChange }) => (
  <div className="flex flex-col rounded-xl gap-1 border border-border bg-card p-1 text-sm font-semibold text-muted-foreground">
    {tabs.map((tab) => {
      const isActive = value === tab.key;
      const Icon = tab.icon;
      return (
        <button
          key={tab.key}
          type="button"
          className={`flex justify-normal rounded-xl px-4 py-2 gap-4 text-sm font-semibold transition ${
            isActive ? "bg-primary/10 text-primary" : "hover:bg-muted/60"
          }`}
          onClick={() => onChange(tab.key)}
        >
          <Icon className="h-4 w-4" />
          <span className="">{tab.label}</span>
        </button>
      );
    })}
  </div>
);

const SettingsPage = () => {
  const { t } = useTran();
  const [activeTab, setActiveTab] = useState("profile");
  const {
    initialProfileValues,
    handleProfileSubmit,
    uniqueUsernameValidator,
    uniqueEmailValidator,
  } = useSettingsProfileForm();
  const { toggles, handlePasswordSubmit } = usePasswordForm();

  return (
    <div className="space-y-6">
      <PageHeader
        title={t("Settings")}
        description={t("settings.description")}
        icon={Settings}
      />
      <div className="grid grid-cols-4 gap-4">
        <div>
          <SectionSwitcher
            value={activeTab}
            onChange={setActiveTab}
            tabs={[
              {
                key: "profile",
                label: t("settings.userInformation"),
                icon: User,
              },
              {
                key: "password",
                label: t("settings.passwordUpdate"),
                icon: KeyRound,
              },
            ]}
          ></SectionSwitcher>
        </div>
        <div className="col-span-3">
          <div className="grid gap-6 items-stretch">
            {activeTab === "profile" ? (
              <ProfileSection
                initialValues={initialProfileValues}
                onSubmit={handleProfileSubmit}
                uniqueUsernameValidator={uniqueUsernameValidator}
                uniqueEmailValidator={uniqueEmailValidator}
              />
            ) : (
              <PasswordSection
                onSubmit={handlePasswordSubmit}
                toggles={toggles}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
